/**
 * dpg-card-atc.js
 * Handles AJAX add-to-cart for dpg-card product cards.
 * Dispatches a 'cart:update' event so the cart icon count updates.
 */

async function handleDpgAtc(button, sourceElement, formData) {
	if (!button || button.disabled) return;

	const originalLabel = button.dataset.atcLabel || button.textContent.trim();
	const addingLabel = button.dataset.atcAdding || 'Adding...';
	const addedLabel = button.dataset.atcAdded || 'Added!';

	button.disabled = true;
	button.textContent = addingLabel;

	try {
		const response = await fetch('/cart/add.js', {
			method: 'POST',
			headers: { Accept: 'application/json' },
			body: formData,
		});

		if (!response.ok) {
			const err = await response.json().catch(() => ({}));
			throw new Error(err.description || err.message || response.statusText);
		}

		button.textContent = addedLabel;

		const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
		if (cartResponse.ok) {
			const cart = await cartResponse.json();
			sourceElement.dispatchEvent(
				new CustomEvent('cart:update', {
					bubbles: true,
					detail: {
						resource: cart,
						sourceId: sourceElement.id || 'dpg-card-atc',
						data: {
							itemCount: cart.item_count,
							source: 'dpg-card-atc',
						},
					},
				})
			);
		}

		const searchModal = /** @type {any} */ (sourceElement.closest('dialog-component.search-modal'));
		if (searchModal && typeof searchModal.closeDialog === 'function') {
			await searchModal.closeDialog();
		}

		if (window.Rebuy?.SmartCart?.status === 'ready') {
			Rebuy.SmartCart.show();
		} else {
			const cartDrawer = /** @type {any} */ (document.querySelector('cart-drawer-component'));
			if (cartDrawer && typeof cartDrawer.open === 'function') {
				cartDrawer.open();
			}
		}

		setTimeout(() => {
			button.disabled = false;
			button.textContent = originalLabel;
		}, 1800);
	} catch (error) {
		button.disabled = false;
		button.textContent = originalLabel;
		console.error('[dpg-card-atc] Add to cart failed:', error);
	}
}

document.addEventListener('click', async function (event) {
	const button = /** @type {HTMLElement | null} */ (event.target instanceof Element ? event.target.closest('[data-dpg-atc-button]') : null);
	if (!(button instanceof HTMLButtonElement)) return;

	event.preventDefault();

	const variantId = button.dataset.variantId;
	if (!variantId) return;

	const formData = new FormData();
	formData.append('id', variantId);
	formData.append('quantity', button.dataset.quantity || '1');

	await handleDpgAtc(button, button, formData);
});

// Fix Yotpo bottomLine stars linking to javascript:void(0) on card pages.
// Intercept clicks in capture phase (before Yotpo's own handlers) and navigate
// to the product URL stored in data-url on the widget container.
document.addEventListener(
	'click',
	function (event) {
		if (!(event.target instanceof Element)) return;
		const yotpoLink = event.target.closest('.yotpo.bottomLine a');
		if (!yotpoLink) return;
		const widget = yotpoLink.closest('.yotpo.bottomLine');
		const url = widget && widget.dataset.url;
		if (!url) return;
		event.preventDefault();
		window.location.href = url + '#yotpo_reviews';
	},
	true
);
